import { render, staticRenderFns } from "./SharedChart.vue?vue&type=template&id=ae36b7ee&scoped=true&"
import script from "./SharedChart.vue?vue&type=script&lang=js&"
export * from "./SharedChart.vue?vue&type=script&lang=js&"
import style0 from "./SharedChart.vue?vue&type=style&index=0&id=ae36b7ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae36b7ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContent } from 'vuetify/lib/components/VContent';
installComponents(component, {VCard,VContent})
